var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcTwitterLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.42883 3.83984L13.5276 17.1048L3.98633 28.1598H6.02008L14.4288 18.4173L21.1113 28.1598H27.5201L17.9988 14.2798L27.0101 3.83984H24.9776L17.0988 12.9673L10.8376 3.83984H4.42883Z",
    fill: "#0D1A16"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTwitterLight);
export default __webpack_public_path__ + "static/media/ic_twitterLight.e423a653cd49e74f99de97a0f0142096.svg";
export { ForwardRef as ReactComponent };